import api from '../utils/api';

class PostsApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/posts', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getGroup = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/posts/group');
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  create = (data) => {
    return new Promise((resolve, reject) => {
      return api
        .post('/posts', data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/posts/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/posts/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  copy = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post(`/posts/copy/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDetail = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/v1/post/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  postToFacebook = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/social/post/facebook/' + id);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  postToTwitter = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/social/post/twitter/' + id);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  sendIndexNow = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/posts/indexNow/send', data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };
}
const postApi = new PostsApi();
export default postApi;
